export const CREATE_DOCUMENT = "CREATE_DOCUMENT";
export const RETRIEVE_DOCUMENTS = "RETRIEVE_DOCUMENTS";
export const UPDATE_DOCUMENT = "UPDATE_DOCUMENT";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const DELETE_ALL_DOCUMENTS = "DELETE_ALL_DOCUMENTS";

